import { render } from "./MovieTicketReservation.vue?vue&type=template&id=104dba76&scoped=true"
import script from "./MovieTicketReservation.vue?vue&type=script&lang=js"
export * from "./MovieTicketReservation.vue?vue&type=script&lang=js"

import "./MovieTicketReservation.vue?vue&type=style&index=0&id=104dba76&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104dba76"]])

export default __exports__